import BHowCollect from './BHowCollect'

export default BHowCollect
